import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgServices = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".abc{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}" }) }),
		/* @__PURE__ */ _jsx("rect", {
			className: "abc",
			x: 1.51,
			y: 2.253,
			width: 21,
			height: 19.5,
			rx: 1.5,
			ry: 1.5
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "abc",
			x1: 1.51,
			y1: 6.753,
			x2: 22.51,
			y2: 6.753
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "abc",
			d: "M15.01,18.753a3,3,0,1,0,0-6c-.085,0-.17,0-.253.012a4.5,4.5,0,1,0-4.247,5.988Z"
		})
	]
});
const ForwardRef = forwardRef(SvgServices);
export default ForwardRef;
